/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForPolicyRemediation extends models.ScheduleExecutionParameterServiceAccountBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForPolicyRemediation");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForPolicyRemediation.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForPolicyRemediation>): ScheduleExecutionParameterForPolicyRemediation {
        let obj = Object.assign(new ScheduleExecutionParameterForPolicyRemediation(), model);
        ScheduleExecutionParameterForPolicyRemediation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForPolicyRemediation>): ScheduleExecutionParameterForPolicyRemediation {
        if (!model) return null;
        return ScheduleExecutionParameterForPolicyRemediation.newInstance(<ScheduleExecutionParameterForPolicyRemediation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForPolicyRemediation) {
        if (!obj) return;

        models.ScheduleExecutionParameterForPolicyRemediation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForPolicyRemediation): boolean {
        if (models.ScheduleExecutionParameterServiceAccountBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForPolicyRemediation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
